import { SET_LANGUAGE } from './types';

export const setLanguage = lang => async dispatch => {
  dispatch({ type: SET_LANGUAGE, payload: lang });
};
